import { formatText } from "../pushNotificationMessage";

const messages = async ({ actionType, notifyContent }) => {

    const message = {
        newEnquiry: {
            title: `Nova consulta`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        declined: {
            title: `Recusado`,
            message: `${formatText(notifyContent['userName'])}: Reserva recusada`
        },
        approved: {
            title: `Aprovado`,
            message: `${formatText(notifyContent['userName'])}: Reserva aprovada`
        },
        newMessage: {
            title: `Nova mensagem`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelReservation: {
            title: `Reserva cancelada`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        newBooking: {
            title: `Nova reserva`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        preApprove: {
            title: `Nova reserva`,
            message: `${formatText(notifyContent['userName'])}: Sua solicitação foi pré-aprovada`
        },
        listApproved: {
            title: `O administrador verificou sua listagem`,
            message: `${formatText(notifyContent['userName'])}: O administrador verificou seu anúncio ${notifyContent['listTitle']}. Publique seu anúncio para receber reservas.`
        },
        listDeclined: {
            title: `O administrador recusou seu anúncio`,
            message: `${formatText(notifyContent['userName'])}: O administrador recusou sua solicitação de listagem para ${notifyContent['listTitle']} devido ao motivo ${notifyContent['reason']}. Por favor, atualize as informações da listagem e envie-as para aprovação.`
        },
        noHostPayout: {
            title: 'Detalhes de pagamento ausentes',
            message: `${formatText(notifyContent['userName'])}:Atualização! Atualize suas informações de pagamento para receber os pagamentos da reserva.`
        },
        approvedDocument: {
            title: `Documento aprovado!`,
            message: `Seu documento foi aprovado com sucesso.`
        },
        rejectDocument: {
            title: `Documento rejeitado!`,
            message: `O documento enviado foi rejeitado pelo administrador. Entre em contato com o administrador para obter mais informações.`
        }
    }

    return message[actionType]
}
export default messages;